import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { OnDestroyComponent } from '../../../../shared/components/on-destroy/on-destroy.component';
import { KazaplanFullscreenService } from '../kazaplan-fullscreen.service';
import { AutoUnsubscribe } from '../../../../utils/misc/auto-unsubscribe';

@Component({
  selector: 'app-kazaplan-fullscreen-diapo',
  templateUrl: './kazaplan-fullscreen-diapo.component.html',
  styleUrls: ['./kazaplan-fullscreen-diapo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@AutoUnsubscribe()
export class KazaplanFullscreenDiapoComponent extends OnDestroyComponent {

  @HostBinding('class.kz-plan3D-fs--medias') hostClass = true;

  public htmlId = 'popin';

  constructor(
    public kfs: KazaplanFullscreenService,
  ) {
    super();
  }
}
